import axios from '@axios'

export default {
    namespaced: true,
    state: {
        infoPallestizado: [],
        infoPallestizadoC:[],
        ubicacion: [],
        camaras: [],
        perchas: [],
        nivel: [{ nivel: 0 }],
        pallets: [],
        layoutCamara: [],
        movimientos: [],
        reserva: [],
    },
    getters: {
        getInfoPalletizado(state) {
            return state.infoPallestizado
        },
        getInfoPalletizadoC(state) {
            return state.infoPallestizadoC
        },
        getPallet(state) {
            return state.pallets
        },
        getCamaras(state) {
            return state.camaras
        },
        getPerchas(state) {
            return state.perchas
        },
        getNivel(state) {
            return state.nivel
        },
        getLayoutCamara(state) {
            return state.layoutCamara
        },
        getMovimientos(state) {
            return state.movimientos
        },
        getReserva(state) {
            return state.reserva
        },
    },
    mutations: {
        setInfoPalletizado(state, infoPallestizado) {
            state.infoPallestizado = infoPallestizado
        },
        setInfoPalletizadoC(state, infoPallestizadoC) {
            state.infoPallestizadoC = infoPallestizadoC
        },
        setUbicacion(state, ubicacion) {
            state.ubicacion = ubicacion
        },
        setPallet(state, pallets) {
            state.pallets = pallets
        },
        setCamaras(state, camaras) {
            state.camaras = camaras
        },
        setPercha(state, perchas) {
            state.perchas = perchas
        },
        setNivel(state, nivel) {
            state.nivel = state.nivel.concat(nivel)
        },
        setLayoutCamara(state, layoutCamara) {
            state.layoutCamara = layoutCamara
        },
        setMovimientos(state, movimientos) {
            state.movimientos = movimientos
        },
        setReserva(state, reserva) {
            state.reserva = reserva
        },
    },
    actions: {
        consultarUbicacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/consultarUbicacion', data)
                    .then(response => {
                        commit('setUbicacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchInfoPallestizado({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/productoTerminado/infoPallestizado/${data}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setInfoPalletizado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        infoPallestizadoCentral({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/productoTerminado/infoPallestizadoCentral/${data}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setInfoPalletizadoC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPallet({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/ubicacion', data)
                    .then(response => {
                        commit('setPallet', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        actualizarSincro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/actualizarSincro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        aprobarPallet({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/aprobarPallet', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchCamaras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/allCamaras', data)
                    .then(response => {
                        commit('setCamaras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPerchas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/columnas/' + data)
                    .then(response => {
                        commit('setPercha', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchNivel({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/filas/' + data.camara + '/' + data.percha)
                    .then(response => {
                        commit('setNivel', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchLayoutCamara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/layoutCamara/' + data)
                    .then(response => {
                        commit('setLayoutCamara', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMovimientos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/movimientos', { params: data })
                    .then(response => {
                        commit('setMovimientos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasReservadas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/etiquetasReservas')
                    .then(response => {
                        commit('setReserva', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        reservarEtiquetas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/productoTerminado/reservar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        impresion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/impresion', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        palletsActivos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/palletsActivos', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        permisoEstablecimiento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/permisoEstablecimiento')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
    },
}
